import { Component, input, ViewEncapsulation } from '@angular/core';

import { Language } from '@helsana/data-access';

import { PriceCalculatorComponent } from '../price-calculator/price-calculator.component';
import { ComponentTypeEnum, ProductConfig } from '@helsana/price-calculator';

@Component({
  selector: 'priced-product-teaser-list-wrapper',
  templateUrl: './priced-product-teaser-list-wrapper.component.html',
  styleUrls: ['./priced-product-teaser-list-wrapper.component.scss'],
  imports: [
    PriceCalculatorComponent
  ],
  encapsulation: ViewEncapsulation.None
})
export class PricedProductTeaserListWrapperComponent {
  language = input<Language>(Language.de);
  promosUrl = input.required<string>();
  portalBaseUrl = input.required<string>();
  productPagePaths = input<string[]>();
  productConfig = input({} as ProductConfig[], {
    transform: (value: string) => JSON.parse(value)
  });

  protected readonly ComponentTypeEnum = ComponentTypeEnum;
}